import {AlertTriangle, CheckCircle2, TrendingDown, TrendingUp} from 'lucide-react'

interface ProfitabilityIndicatorProps {
  roas: number
}

function getTier(roas: number) {
  if (roas < 1.0) {
    return {
      label: "Losing money",
      color: "bg-red-500",
      textColor: "text-red-800",
      bgColor: "bg-red-50",
      borderColor: "border-red-200",
      icon: TrendingDown,
      width: "15%",
    }
  }
  if (roas < 2.0) {
    return {
      label: "Low margin / breakeven risk",
      color: "bg-amber-500",
      textColor: "text-amber-800",
      bgColor: "bg-amber-50",
      borderColor: "border-amber-200",
      icon: AlertTriangle,
      width: "40%",
    }
  }
  if (roas < 4.0) {
    return {
      label: "Healthy performance",
      color: "bg-emerald-500",
      textColor: "text-emerald-800",
      bgColor: "bg-emerald-50",
      borderColor: "border-emerald-200",
      icon: CheckCircle2,
      width: "70%",
    }
  }
  return {
    label: "Excellent return",
    color: "bg-emerald-600",
    textColor: "text-emerald-800",
    bgColor: "bg-emerald-50",
    borderColor: "border-emerald-200",
    icon: TrendingUp,
    width: "100%",
  }
}

function ProfitabilityIndicator({ roas }: ProfitabilityIndicatorProps) {
  const tier = getTier(roas)
  const Icon = tier.icon

  return (
    <div className={`rounded-xl border px-4 py-3.5 ${tier.bgColor} ${tier.borderColor}`}>
      <div className="flex items-center justify-between gap-3 mb-2.5">
        <div className="flex items-center gap-2">
          <Icon className={`w-4 h-4 ${tier.textColor}`} />
          <span className={`text-[13px] font-semibold ${tier.textColor}`}>{tier.label}</span>
        </div>
        <span className="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-500">Campaign health</span>
      </div>
      <div className="w-full h-1.5 rounded-full bg-white/80 overflow-hidden">
        <div className={`h-full rounded-full ${tier.color} transition-all duration-300`} style={{ width: tier.width }} />
      </div>
    </div>
  )
}

export default ProfitabilityIndicator
